import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="bauchartVsGeorgeV" locale="fr" />

export default Page
